import EventsList from "../../components/eventsList/EventsList";
import VideoSection from "./videoSection/VideoSection";
import MainInformation from "./mainInformation/MainInformation";
import OurPhilosophy from "./ourPhilosophy/OurPhilosophy";
import { motion } from "motion/react";
import { INITIAL, ANIMATE, TRANSITION } from "../../utils/constants";
import { Helmet } from "react-helmet-async";

export default function LandingPage() {
  return (
    <>
      <Helmet>
        <title>ACTIVE Generation</title>
        <meta
          name="description"
          content="ACTIVE Generation – це ініціативна громадська спільнота, яка сприяє всебічному розвитку лідерства серед української молоді та просуває ідею неформальної освіти"
        />
        <meta
          property="og:title"
          content="ACTIVE G Project - Онлайн Школа Лідерів Майбутнього"
        />
        <meta
          property="og:description"
          content="ACTIVE Generation – це ініціативна громадська спільнота, яка сприяє всебічному розвитку лідерства серед української молоді та просуває ідею неформальної освіти"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <motion.div initial={INITIAL} animate={ANIMATE} transition={TRANSITION}>
        <MainInformation />
        <OurPhilosophy />
        <EventsList />
        <VideoSection />
      </motion.div>
    </>
  );
}
